export default __webpack_public_path__ + "src/assets/icn-walking.9aa4dcd7fb9aa61d1eef91b8414fe1f9.svg";